import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Params} from '@angular/router/src/shared';
import {Observable} from 'rxjs';
import {
  IntegratedPlatform,
  IntegrationModel,
  IntegrationPlatformImport,
  IntegrationPlatformType
} from 'app/integrations/models/integration.model';
import {disabledNotification} from 'app/config/http-errors.interceptor';
import {disabledProgress} from '../config/progress.inteceptor';

@Injectable()
export class IntegrationsService {
  constructor(private http: HttpClient) {}

  initIntegration(type: IntegrationPlatformType, param: HttpParams): Observable<any> {
    return this.http.get(`/integrations/init/${this.toPath(type)}`, { params: param });
  }

  confirmIntegration(type: IntegrationPlatformType, params: Params): Observable<any> {
    return this.http.post(`/integrations/${this.toPath(type)}`, params, disabledNotification);
  }

  checkIntegrationStatuses(): Observable<IntegrationModel[]> {
    return this.http.get<IntegrationModel[]>('/integrations/status');
  }

  checkIntegrationStatus(type: IntegrationPlatformType): Observable<IntegrationModel> {
    return this.http.get<IntegrationModel>(`/integrations/status/${type}`, disabledProgress);
  }

  importOldContacts(type: IntegrationPlatformType, resync: boolean = false): Observable<any> {
    return this.http.post(`/integrations/import/${this.toPath(type)}`, {}, { params: { resync: `${resync}` } });
  }

  getIntegration(type: IntegrationPlatformType): Observable<IntegratedPlatform> {
    return this.http.get<IntegratedPlatform>(`/integrations/${this.toPath(type)}`);
  }

  getLatestImport(type: IntegrationPlatformType): Observable<IntegrationPlatformImport> {
    return this.http.get<IntegrationPlatformImport>(`/integration/import/latest`, { params: { platform: type } });
  }

  getApiKey(): Observable<{ apiKey: string }> {
    return this.http.get<{ apiKey: string }>(`/users/api-key`, { params: { generateOnEmpty: 'true' } });
  }

  deleteIntegration(type: IntegrationPlatformType): Observable<any> {
    return this.http.delete(`/integrations/${this.toPath(type)}`);
  }

  toggleAutoResync(type: IntegrationPlatformType, enabled: boolean): Observable<any> {
    return this.http.put(
      `/integrations/${this.toPath(type)}/toggle-auto-resync`,
      {},
      { params: { enabled: `${enabled}` } }
    );
  }

  private toPath(integratedPlatformType: IntegrationPlatformType): string {
    return integratedPlatformType.toString().toLocaleLowerCase();
  }
}
